import RestService from '@/modules/backend/RestService';
import { plainToClass } from 'class-transformer';
import { SearchRequestData } from '@/modules/backend/Dto/SearchRequestData';
import { SearchResponseData } from '@/modules/backend/Dto/SearchResponseData';

export default class Search {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async search(payload: SearchRequestData): Promise<SearchResponseData> {
    const entityList = payload.entities.join(',');
    const query = payload.query;

    if (entityList && query) {
      const response = await this.rest.get<unknown>(
        `/api/v1/search?entities=${entityList}&query=${query}`
      );
      return plainToClass(SearchResponseData, response);
    }

    return plainToClass(SearchResponseData, {});
  }
}
